import { showErrorsFromRequest } from '../api/showErrorsFromRequest';
import { userApi } from '../api/user/userApi';

export const getUserIdentity = async ({ setUser, setIsAuthenticated, t }) => {
  try {
    const response = await userApi.userIdentity();
    setUser({
      firstName: response.data.firstName,
      lastName: response.data.lastName,
      email: response.data.email,
      isAdmin: response.data.isAdmin,
      permissions: response.data.permissions,
      phoneNumber: response.data.phoneNumber,
      company: response.data.company,
      role: response.data.role
    });
    setIsAuthenticated(true);
  } catch (error) {
    showErrorsFromRequest(error, t);
    setIsAuthenticated(false);
    setUser(null);
    return null;
  }
};
